<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->

<template>
	<div class="website-setup website-setup__body">
		<div>
			<div class="mdc-layout-grid website-setup__grid">
				<div class="mdc-layout-grid__inner center-horizontal mdc-theme--dark mdc-theme--text-primary-on-dark">

					<!-- LANDING MESSAGE -->
					<section class="section-landing mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage == stages.LANDING">
						<h2>Create your website</h2>
						<div class="website-setup__icon"><img src="/static/img/website-setup.png" alt="" class=""></div>
						<h3 class="website-setup__landing-text">Create your<br> company's website<br> in just <span>2 easy steps</span></h3>
						<a class="mdc-button mdc-button--raised" @click.prevent="stage = stages.ABOUT">Let's go!</a>
					</section>

					<!-- ABOUT US TEXT AND PHOTO -->
					<section class="section-about mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage == stages.ABOUT">
						<h3 class="margin-bottom-40">Tell us a little bit about your company and add a photo</h3>
						<div for="about-us" class="website-setup__about-label">About Us</div>
						<div class="mdc-textfield mdc-textfield--textarea">
							<textarea id="about-us" class="website-setup__about-textarea mdc-textfield__input description-textarea" v-model="site.aboutUs.about"></textarea>
						</div>
						<div class="website-setup__hint margin-bottom-40">Don't worry you can change this later.</div>
						<s3 class="website-setup__upload-btn" :single="true" label="Add a team photo" key="s3-images" v-model="site.aboutUs.images" @complete="imageUploaded = true" @uploading="isUploading = arguments[0]"></s3>
						<div class="website-setup__hint margin-bottom-40">You can add a photo later if you don't have one now.</div>
						<div v-if="site.aboutUs.images.length > 0" class="s3__image-grid">
							<div class="s3__image" :style="{backgroundImage: 'url(\'' + s3url(site.aboutUs.images, 'small') + '\')'}">
								<span class="editable-photos__remove-btn" @click="removeImage()"><i class="ico ico-delete"></i></span>
							</div>
						</div>
						<a class="mdc-button mdc-button--raised" @click.prevent="stage = stages.LOGO">Next</a>
						<div class="btn-back"><a @click.prevent="stage = stages.LANDING">&lt; back</a></div>
					</section>

					<!-- LOGO UPLOAD  -->
					<section class="section-logo mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage == stages.LOGO">
						<h3 class="margin-bottom-40">You may also add your logo here. Or you can do it later.</h3>
						<s3 class="website-setup__upload-btn" :single="true" label="Add your logo" key="s3-logo" v-model="site.logo" @complete="logoUploaded = true" @uploading="isUploading = arguments[0]"></s3>
						<div v-if="site.logo.length > 0" class="s3__image-grid">
							<div class="s3__image" :style="{backgroundImage: 'url(\'' + s3url(site.logo, 'small') + '\')'}">
								<span class="editable-photos__remove-btn" @click="removeLogo()"><i class="ico ico-delete"></i></span>
							</div>
						</div>
						<button-with-spinner class="btn--spinner__wide-btn" :isSaving="isSaving" :text="isSaving ? 'Creating website...' : 'Save'" :customMethod="createSite" :disabled="isSaving"></button-with-spinner>
						<div class="btn-back"><a @click.prevent="stage = stages.ABOUT">&lt; back</a></div>
					</section>

					<!-- SUCCESS -->
					<section class="section-success mdc-theme--primary-dark-bg mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="stage == stages.SUCCESS">
						<!-- <div class="" v-if="finalUrl !=''"> -->
						<div>
							<h2>The <span class="website-setup__company-name">{{ titleCase(companyName) }}</span> website was created.</h2>
							<div class="website-setup__icon website-setup__success-icon"><img src="/static/img/success_thumbs.png" alt="" class=""></div>
							<!-- <h2>Would you like your own domain?</h2>
							<a href="#">I already have a domain</a>
							<a href="#">Buy a domain</a> -->
							<p><a :href="finalUrl" target="_blank" class="mdc-button mdc-button--raised">Take me to my website</a></p>
							<p>Here's your website's URL: </p>
							<span class="website-setup__url" target="_blank">{{ finalUrl }}</span> <br><br>
							<span class="website-setup__hint">Only people with this link willl find you.</span>
							<p>You can now add your social media links and other website details here: <br>
							<a href="/settings/website">Website Settings</a></p>

							<!-- Share buttons -->

						</div>
					</section>
				</div>
			</div>
		</div>
	</div>
</template>


<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import ButtonWithSpinner  from '../components/ButtonWithSpinner.vue';
import GooglePlacesInput  from '../components/GooglePlacesInput.vue';
import AddressInput      from '../components/AddressInput.vue';
import S3                 from '../components/S3.vue';
import Vue                from 'vue';
import VeeValidate       from 'vee-validate';
import ProgressSteps			 from '../components/ProgressSteps.vue';

Vue.use(VeeValidate);

export default {
	data: function() {
		return {
			stages: {
				LANDING:	0,
				ABOUT:		1,
				LOGO:			2,
				SUCCESS:	3
			},
			stage: 0,
			site: {
				logo: '',
				aboutUs:{
					about: '',
					images: ''
				},
				contacts: {
					email: ''
				},
				footerContents: {
					thePropertyOmbudsman: false,
					ombudsmanServices: false,
					propertyRedressScheme: false,
					naea: false,
					arla: false,
					rics: false,
					rightmove: false,
					zoopla: false,
					onTheMarket: false
				},
				socialMedia: {
					facebook: '',
					twitter: '',
					instagram: '',
					linkedIn: ''
				},
			},
			isSaving: false,
			finalUrl: '',
			defaultAddress: '',
			isUploading: false,
			websiteLoaded: false,
		}
	},
	mixins: [utils],
	computed: {
		getStages: function() {
			var stages = Object.values(this.stages);

			return stages;
	  },
	  companyName: function(){
			return this.$store.getters.companyName;
		}
	},
	components: {
		'button-with-spinner': ButtonWithSpinner,
		'google-places-input': GooglePlacesInput,
		'address-input': AddressInput,
		's3': S3,
		'progress-steps': ProgressSteps
	},
	mounted: async function(){
		this.site.aboutUs.about = this.titleCase(this.companyName) + ' is your friendly local agency. We work harder to help you get the best price for your property with the minimum of fuss. Moving home can be daunting, but we’re here to help every step of the way. We want to be the best, not the biggest, and we use the latest technology to make sure we’re never too busy to talk to you.';
	},
	methods: {
		createSite: async function() {
			this.isSaving = true;
			try {
				const response = await api({endpoint: this.config.services.website, path: '/create-site', method: 'POST', body: this.site});
				this.finalUrl = response.url;
				this.stage = this.stages.SUCCESS;
			} catch(err) {
				alert('Sorry, something went wrong...');
				console.error('Error creating site:', err);
			}
			this.isSaving = false;
		},
		removeImage: function() {
			if (confirm('Are you sure you want to delete this photo?')) {
				this.site.aboutUs.images = '';
			}
		},
		removeLogo: function() {
			if (confirm('Are you sure you want to delete this logo?')) {
				this.site.logo = '';
			}
		},
		titleCase: function(str) {
   		var splitStr = str.toLowerCase().split(' ');
			for (var i = 0; i < splitStr.length; i++) {
				splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
			}
   			// Directly return the joined string
   			return splitStr.join(' ');
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Website-Setup.vue